import React from 'react';

import Layout from '@components/layout';

function MainPage(props) {
  return <div />;
}

export default MainPage;
